import { FormValues } from '../../duck';
import { Box, Button, Flex } from '@chakra-ui/react';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import { TextInput, TextInputInstance } from '@lon/mathnation-suit/components';
import { generatePassword } from './duck';

const Form: React.FC = () => {
  const { reset, formState, setValue } = useFormContext<FormValues>();

  const ref = React.useRef<TextInputInstance | null>(null);

  return (
    <Flex flexDirection="column" flex="50%" p={4} gridGap={4}>
      <Box position="relative">
        <TextInput
          isRequired
          name="newPassword"
          label="New Password"
          placeholder="Enter new password"
          type="password"
          autoComplete="off"
          instanceRef={ref}
        />
        <Button
          size="xs"
          position="absolute"
          top={0}
          right={0}
          variant="ghost"
          colorScheme="blue"
          onClick={() => {
            setValue('newPassword', generatePassword(16), {
              shouldValidate: true,
            });
            if (ref.current) {
              ref.current.togglePassword(true);
            }
          }}
        >
          Generate
        </Button>
      </Box>
      <TextInput
        isRequired
        autoComplete="off"
        name="confirmPassword"
        label="Confirm New Password"
        placeholder="Repeat new password"
        type="password"
      />
      <Flex justifyContent="space-between" w="100%" mt="auto">
        <Button
          colorScheme="blue"
          variant="outline"
          onClick={() => {
            reset({ newPassword: '', confirmPassword: '' });
          }}
        >
          Clear All
        </Button>
        <Button
          colorScheme="blue"
          variant="solid"
          isLoading={formState.isSubmitting}
          type="submit"
        >
          Update
        </Button>
      </Flex>
    </Flex>
  );
};

export default Form;
